/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function DateRangeFromJSON(json) {
    return DateRangeFromJSONTyped(json, false);
}
export function DateRangeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'start': !exists(json, 'start') ? undefined : json['start'],
        'timeZone': !exists(json, 'timeZone') ? undefined : json['timeZone'],
        'end': !exists(json, 'end') ? undefined : json['end']
    };
}
export function DateRangeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'start': value.start,
        'timeZone': value.timeZone,
        'end': value.end
    };
}
